export const FETCH_SSO_TOKEN_REQUEST = 'FETCH_SSO_TOKEN_REQUEST';
export const FETCH_SSO_TOKEN_SUCCESS = 'FETCH_SSO_TOKEN_SUCCESS';
export const FETCH_SSO_TOKEN_FAILURE = 'FETCH_SSO_TOKEN_FAILURE';